import { DataService, ApiService } from "../service";
import { Category } from '@/libs';

export class ProdFavoriteService {
 
  static async getProdList(page:Number=1,pageSize:Number=10,dirId:number,q:string="") {
    const url = `${ApiService.JrzzApi}/favorite/prod/list?page=${page}&pageSize=${pageSize}&dirId=${dirId}&q=${q}`;
    const result = await DataService.get(url);
    try {
      return result;
    } catch (error) {
      // @ts-ignore
      console.error(error.message || '')
    }
  }
  static async del(dataId:String,dirID:number) {

    const url = `${ApiService.JrzzApi}/data/${Category.ProdFavoriteDir}/${Category.ProdFavorite}/delete?dirId=${dirID}&dataId=${dataId}`;
    const result = await DataService.post(url);
    try {
      return result;
    } catch (error) {
      // @ts-ignore
      console.error(error.message || '')
    }
  }
}
